import { black } from '@/constants/Colors';
import { subtitulo } from '@/constants/Dimens';
import { Typography } from '@mui/material';


//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface TituloH1Props {
    texto: string;
    color?: string;
    fontSize?: string;
}

function Subtitulo({ texto, color, fontSize = subtitulo }: TituloH1Props) {

    //Tamaño de texto a 25 px
    //Color de texto a primario

    const style: React.CSSProperties = {
        fontSize: fontSize,
        color: color ? color : black,
        fontWeight: '300',
        userSelect: 'none',
        marginLeft: '10px',
        marginRight: '10px',
    };


    return (
        <Typography sx={{ mt: 1 }} style={style} dangerouslySetInnerHTML={{ __html: texto }} component="div">
        </Typography>
    );

}

export default Subtitulo;
